/*** IMPORTS FROM imports-loader ***/
var pixi = require("pixi");
var p2 = require("p2");

module.exports = global["Phaser"] = require("-!./phaser-split.js");



//////////////////
// WEBPACK FOOTER
// ./~/phaser-ce/build/custom/phaser-split.js
// module id = 72
// module chunks = 3